import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  urls: {
    api: '',
    base: 'https://www.blocket.se',
  },
  chatAppID: '',
})

const config = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_BASE_URL:
      return state.setIn(['urls', 'base'], payload)
    case actions.SET_API_URL:
      return state.setIn(['urls', 'api'], payload)
    case actions.SET_CHAT_APP_ID:
      return state.set('chatAppID', payload)
    default:
      return state
  }
}

export default config
